/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import styled from 'styled-components';

import { toInteger } from 'lodash';

const defaultColor = '#EFEDFF';
const defaultHoverColor = '#6347FF';

const PieChartContainer = styled.div`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
`;

const SvgContainer = styled.svg`
    width: ${(props) => props.size};
    height: ${(props) => props.size};
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 200px;
    clip-path: circle(50%);
`;

const PathContainer = styled.path`
    position: relative;
`;

// Takes Polar Coordinates and calculates the Cartesian equivalent
function polarToCartesian(centerX, centerY, radius, angleIntoDegrees) {
    var angleInRadians = ((angleIntoDegrees - 90) * Math.PI) / 180.0;

    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
}
const FindCenter = ({ radius, startAngle, endAngle, strokeWidth }) => {
    var start = polarToCartesian(radius, radius, radius - strokeWidth / 3, startAngle);

    var x = start.x.toFixed().concat('px');
    var y = start.y.toFixed().concat('px');
    return <InfoModal x={x} y={y}></InfoModal>;
};
const ModalContainer = styled.div`
    display: block;
    position: absolute;
    width: 200px;
    height: 200px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    z-index: -1;
`;

const InfoModal = styled.div`
    display: block;
    position: absolute;
    left: ${(props) => props.x};
    top: ${(props) => props.y};
    width: 5px;
    height: 5px;
    background-color: red;
`;

// Draws an elliptical Arc using SVG paths
const DrawArc = ({
    radius,
    startAngle,
    endAngle,
    singleData,
    strokeWidth,
    hover,
    defaultC,
    student,
    selected,
    handleArcEnter,
    handleArcLeave,
    handleClick,
}) => {
    const center = radius;
    var start = polarToCartesian(center, center, radius, startAngle);
    var end = polarToCartesian(center, center, radius, endAngle);
    var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    var d;
    var strokeColor = defaultColor;

    if (singleData) {
        d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 1, end.x, end.y, 'Z'].join(' ');
    } else {
        d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 1, end.x, end.y].join(' ');
    }

    if (!hover) {
        return <PathContainer fill='none' strokeLinecap='butt' stroke={strokeColor} strokeWidth={strokeWidth} d={d} />;
    }

    if (defaultC) {
        strokeColor = selected == student.id ? defaultHoverColor : defaultColor;
    } else {
        strokeColor = selected == student.id ? student.hoverColor || defaultHoverColor : student.color || defaultColor;
    }

    return (
        <PathContainer
            fill='none'
            strokeLinecap='butt'
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            d={d}
            cursor={'pointer'}
            onMouseEnter={handleArcEnter}
            onMouseLeave={handleArcLeave}
            onClick={() => handleClick()}
        />
    );
};

const PieChart = ({
    graphDiameter,
    strokeWidth,
    students,
    hover = false,
    gap = 0,
    defaultColor = false,
    selectedDefault,
    selected,
    onEnter = () => {
        return;
    },
    onExit = () => {
        return;
    },
    handleClick = () => {
        return;
    },
    ...props
}) => {
    const graphRadius = toInteger(graphDiameter) / 2;
    graphDiameter = graphDiameter.concat('px');
    strokeWidth = toInteger(strokeWidth) * 2;

    var i;
    var data = [];
    var studentPoints;
    for (i = 0; i < students.length; i = i + 1) {
        studentPoints = students[i].tasks[0] * 4 + students[i].tasks[1] * 2 + students[i].tasks[2];
        if (studentPoints != 0) {
            data.push(studentPoints);
        }
    }

    var angle = [0];
    var singleData = false;
    if (data.length == 1) {
        angle.push(359);
        singleData = true;
    } else {
        var total = 0;
        var adder = 0;
        var toDegree = [];
        data.map((element) => (total += element));
        data.map((element) => toDegree.push((element / total) * 360));
        toDegree.map((element) => angle.push((adder += element)));
    }

    return (
        <PieChartContainer size={graphDiameter}>
            <SvgContainer size={graphDiameter}>
                {data.map((element, i) => (
                    <DrawArc
                        radius={graphRadius}
                        diameter={graphDiameter}
                        startAngle={angle[i] + gap}
                        endAngle={angle[i + 1]}
                        strokeWidth={strokeWidth}
                        id={angle[i]}
                        singleData={singleData}
                        hover={hover}
                        defaultC={defaultColor}
                        student={students[i]}
                        selected={selected}
                        handleArcEnter={() => onEnter(i)}
                        handleArcLeave={() => onExit(i)}
                        handleClick={() => handleClick(i)}
                    ></DrawArc>
                ))}
            </SvgContainer>
            {/**<ModalContainer>
                {data.map((element, i) => (
                    <FindCenter
                        radius={graphRadius}
                        strokeWidth={strokeWidth}
                        startAngle={(angle[i] + angle[i + 1]) / 2}
                        endAngle={angle[i + 1]}
                    ></FindCenter>
                ))}
                </ModalContainer>*/}
        </PieChartContainer>
    );
};

export default PieChart;
